import { logEngagement, logEngagementWithDetails } from "modules/global/log-engagement";

$(function() {
  bindResetButton($('.smart-filters__generated-questions'));

  const $originalSearchTerm = $('#original-search-term');
  if ($originalSearchTerm.length) {
    const correctedSearchTerm = $('#smart_search_term').val();
    const originalSearchTerm = $originalSearchTerm.text();
    window.history.replaceState(null, document.title,
      window.location.href.replace('search=' + encodeURIComponent(originalSearchTerm),
        'search=' + correctedSearchTerm));
  }

  $('.js-smart-filters').on('click', function(e) {
    $.modal({
      open: 'smart-filters',
      type: 'custom',
      triggerOpen: true,
      triggerElement: $(this),
      onClose: function() {
        const $form = $('#smart-filters-form');
        const fieldsetId = $form.data('fieldsetId');
        if (fieldsetId) {
          const $fieldset = $(`#${fieldsetId}`);
          const originalIndex = $fieldset.data('index');
          if (originalIndex) {
            $('fieldset', $form).eq(originalIndex - 1).after($fieldset);
          }
        }
        $form.data('fieldsetId', '');
      },
    });
    if (e && e.originalEvent) {
      logEngagement(window.location.href, 'smart_filter_pill_more', 'click');
    }
  });

  $('.js-smart-filter-question').on('click', function(){
    const $this = $(this);
    const fieldsetId = $this.data('fieldsetId');
    $('#smart-filters-form').data('fieldsetId', fieldsetId).prepend($(`#${fieldsetId}`));
    $('.js-smart-filters').trigger('click');
    logEngagementWithDetails(window.location.href, 'smart_filter_pill', 'click', $this.data('category'));
  });
});

function getSearchScope(el) {
    const $modal = $(el).closest('.modal');
    return $modal.length ? $modal : $(document);
}

function updateClearSearchVisibility($scope) {
    const $input = $scope.find('.smart-filters__search__textbox').first();
    const $clear = $scope.find('.js-clear-search').first();

    if (!$input.length || !$clear.length) return;

    const hasText = $.trim($input.val()).length > 0;
    const isFocused = $input.is(':focus');

    $clear.toggle(hasText && isFocused);
}

// bind for both modal + page inputs
$(document)
    .off('input.js-smart-filters-search focus.js-smart-filters-search blur.js-smart-filters-search', '.smart-filters__search__textbox')
    .on('input.js-smart-filters-search', '.smart-filters__search__textbox', function () {
        updateClearSearchVisibility(getSearchScope(this));
    })
    .on('focus.js-smart-filters-search', '.smart-filters__search__textbox', function () {
        updateClearSearchVisibility(getSearchScope(this));
    })
    .on('blur.js-smart-filters-search', '.smart-filters__search__textbox', function () {
        const $scope = getSearchScope(this);
        setTimeout(() => updateClearSearchVisibility($scope), 0);
    });

// clear button: clears textbox in same scope (modal clears modal input, page clears page input)
$(document)
    .off('pointerdown.js-smart-filters-search mousedown.js-smart-filters-search', '.js-clear-search')
    .on('pointerdown.js-smart-filters-search', '.js-clear-search', function (e) {
        e.preventDefault();

        const $scope = getSearchScope(this);
        const $input = $scope.find('.smart-filters__search__textbox').first();

        if (!$input.length) return;

        $input.val('').trigger('input').focus();
        updateClearSearchVisibility($scope);
    });

// Resets this module's UI only. The #reset-smart-filters click is owned by the
// search entry point, which clears the filter data and submits, then triggers
// this event -- so the submit reads form state before the search box is cleared.
function bindResetButton($container) {
  $(document)
    .off('smartFilters:reset.smartFiltersReset')
    .on('smartFilters:reset.smartFiltersReset', function () {
      // Uncheck modal UI
      $container.find('input[type="checkbox"]').prop('checked', false);

      // Clear search UI bits if needed
      $('.smart-filters__search__textbox').val('');
      updateClearSearchVisibility($('.modal'));

      $('.js-modal-close').trigger('mousedown');
    });
}



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/smart-filters.js